import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Pencil } from "lucide-react";

const Field = ({ id, label, value, onChange, placeholder }) => (
  <label className="block">
    <span className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0]">{label}</span>
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={`socials-${id}`}
      className="mt-1 w-full bg-[#121212] border border-[#3a3a3a] focus:border-[#cfff04] focus:outline-none px-3 py-2 font-mono text-sm"
    />
  </label>
);

/** Owner-only editor for self-declared X / Telegram / website links. */
export default function SocialsEditor({ coin, onSaved }) {
  const [open, setOpen] = useState(false);
  const [x, setX] = useState(coin.x_handle || "");
  const [tg, setTg] = useState(coin.telegram || "");
  const [site, setSite] = useState(coin.website || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.patch(`/coins/${coin.slug}/socials`, { x_handle: x, telegram: tg, website: site });
      toast.success(r.data.trust?.verified ? "Links saved — you're SolSpur Verified!" : "Links saved");
      setOpen(false);
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't save links");
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        data-testid="socials-edit"
        className="font-mono text-[11px] uppercase tracking-widest text-[#cfff04] hover:underline inline-flex items-center gap-1"
      >
        <Pencil size={9} /> {coin.x_handle ? "Edit creator links" : "Link your X account"}
      </button>
    );
  }

  return (
    <div className="mt-3 grid gap-3 sm:grid-cols-3" data-testid="socials-editor">
      <Field id="x" label="X handle" value={x} onChange={setX} placeholder="@yourhandle" />
      <Field id="telegram" label="Telegram" value={tg} onChange={setTg} placeholder="t.me/yourgroup" />
      <Field id="website" label="Website" value={site} onChange={setSite} placeholder="https://" />
      <div className="sm:col-span-3 flex items-center gap-3">
        <button
          onClick={save}
          disabled={busy}
          data-testid="socials-save"
          className="btn-brutal bg-[#cfff04] text-[#050505] font-bold uppercase tracking-wider text-[11px] px-4 py-2 inline-flex items-center gap-1"
        >
          {busy ? <Loader2 size={10} className="animate-spin" /> : null} Save links
        </button>
        <button
          onClick={() => setOpen(false)}
          data-testid="socials-cancel"
          className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] hover:text-white"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
